import {
  Row,
  Col,
  Divider,
  Form,
  Input,
  Button,
  Typography,
  message,
  Card,
} from "antd";
import LoginSignupScreen from "./loginSignupScreen";
import { useDispatch, useSelector } from "react-redux";
import { NavLink as Link, useNavigate } from "react-router-dom";
//Action

import { resendOtpByEmailAction } from "../store/action/admin/authActions";
import { css, keyframes } from "emotion";
import EmailIcon from "../Icons/EmailIcon";
import { themeAction } from "../store/action/admin/themeActions";
import { langaugeTanslatorAction } from "../store/action/admin/languageTranslatorActions";

const { Title } = Typography;
const fadeInAndFloat = keyframes`
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const floatingAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
`;

const cardStyle = css`
  animation: ${fadeInAndFloat} 1s forwards,
    ${floatingAnimation} 3s ease-in-out infinite;
`;
function LoginEmailCard() {
  const router = useNavigate();
  const resendOtpByEmailList = useSelector(
    (state) => state.resendOtpByEmailList
  );
  const { resendOtpByEmailLoading, resendOtpByEmailError } =
    resendOtpByEmailList;

  const queryParams = new URLSearchParams(window.location.search);
  const redirect_back = queryParams.get("redirect_back"); // Retrieves the "redirect_back" parameter

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const onFinish = async (values) => {
    const email = values.email;
    const emails = email.toLowerCase();
    const data = {
      email: emails,
    };
    try {
      await dispatch(resendOtpByEmailAction(data));
      dispatch(themeAction());
      dispatch(langaugeTanslatorAction("en"));
      sessionStorage.setItem("email", emails);
      router(
        "/login/email/otp" +
          (redirect_back ? `?redirect_back=${redirect_back}` : "")
      );

      form.resetFields();
    } catch (error) {
      message.error("Please try again later");
    }
  };

  return (
    // <Row
    //   style={{
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     height: "100vh",
    //   }}
    // >
    //   <Col span={8}>
    //     <Card
    //
    //       className={cardStyle}
    //       style={{
    //         borderRadius: "32px",
    //         padding: "30px",
    //       }}
    //     >
    //       <Row>
    //         <Col span={24}>
    //           <Title level={2}>Maximize your Efficiency</Title>
    //           <p className="subtitle-Body-Large-Subtle subtitle-Body-Large-padding">
    //             Streamline your Time and Productivity
    //           </p>
    //           <Divider />
    //         </Col>
    //         <Col span={24}>

    <Form
      form={form}
      name="normal_login"
      className="login-form"
      layout="vertical"
      autoComplete="on"
      initialValues={{ remember: true }}
      onFinish={onFinish}
    >
      <Row
        gutter={[0, 0]}
        style={{ marginTop: "25px" }}
        className={css`
          .ant-input-outlined {
            height: clamp(38px, 3vw, 48px) !important;
            font-family: "Inter", sans-serif !important;
            font-size: clamp(12px, 0.8vw, 14px) !important;
          }
        `}
      >
        <Col span={24}>
          <Form.Item
            name="email"
            // label="Email*"
            rules={[
              {
                required: true,
                message: "Enter your Email Address",
              },
            ]}
          >
            <Input
              style={{
                height: "48px",
                borderRadius: "20px",
              }}
              prefix={
                <EmailIcon
                  style={{
                    margin: "0px 5px",
                    marginLeft: "7px",
                    color: "#d6d6d6",
                  }}
                />
              }
              placeholder="Enter your Email Address"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          {resendOtpByEmailError && (
            <p style={{ color: "red" }}>{resendOtpByEmailError}</p>
          )}
        </Col>{" "}
        <Col
          span={24}
          style={{ marginTop: 5 }}
          className={css`
            .ant-btn {
              height: 40px !important;
            }
          `}
        >
          <Form.Item noStyle>
            <Button
              type="primary"
              htmlType={"submit"}
              size="large"
              loading={resendOtpByEmailLoading}
              style={{ width: "100%", borderRadius: "20px" }}
            >
              Login
            </Button>
          </Form.Item>
        </Col>
        {/* <Col span={24} align="center">
          <Link to="/login-via-phone">
            <Button type="text">Login via Phone</Button>
          </Link>
          <Link to="/login">
            <Button type="text">Login via Email & Password</Button>
          </Link>
        </Col> */}
        {/* <Col span={24} align="left">
          <p
            className="spacer-medium"
            style={{ fontSize: 14, fontWeight: 600 }}
          >
            Don't have an account?{" "}
            <Link to="/signup">
              <span style={{ color: "#f47e63" }}> Register now!</span>
            </Link>
          </p>
        </Col> */}
      </Row>
    </Form>
    //         </Col>
    //       </Row>
    //     </Card>
    //   </Col>
    // </Row>
  );
}

export default LoginEmailCard;
